import { authConstants } from '../constants';

export function ForgotPassword(state = {}, action) {
  switch (action.type) {
    case authConstants.FORGOTPASSWORD_REQUEST:
      return { 
        user: action.user
       };
    case authConstants.FORGOTPASSWORD_SUCCESS:
      return {
        forgotPassword: action.response
      };
    case authConstants.FORGOTPASSWORD_FAILURE:
      return {
        error: action.error
      };
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/store/reducers/forgotPassword.reducer.js